// src/pages/Workshop2.js

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Workshop2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stripeLink = "https://buy.stripe.com/cNi14o5Jg9jm1Pc4dV9oc0M";

  return (
    <>
      <Helmet>
        <title>Workshop 2 | Little Hibba</title>
        <meta name="description" content="A Publisher’s Mainstream Marketing Steps – Copy Them for Your Book" />
      </Helmet>

      <style>{`
        .workshop-hero { background-color: #f2f7fa; padding: 120px 0 60px 0; }
        .classy-heading { font-family: 'Playfair Display', serif; color: #1a365d; }
        .text-reading { font-size: 1.1rem; line-height: 1.8; color: #4a5568; }
        .sticky-card { position: sticky; top: 120px; border: none; border-radius: 20px; box-shadow: 0 10px 40px rgba(0,0,0,0.08); overflow: hidden; }
        .list-icon { color: #d4af37; margin-right: 12px; font-size: 1.2rem; }
        ul.custom-list { list-style: none; padding-left: 0; }
        ul.custom-list li { margin-bottom: 15px; display: flex; align-items: flex-start; }
      `}</style>

      <section className="workshop-hero">
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={10} lg={8}>
              <span className="badge bg-white text-primary border border-primary px-3 py-2 rounded-pill text-uppercase mb-4">Workshop 2</span>
              <h1 className="classy-heading display-4 fw-bold mb-4">A Publisher’s Mainstream Marketing Steps – Copy Them for Your Book</h1>
              <p className="lead text-muted">Big publishers don’t guess at launches. Copy their proven campaign steps, but make them halal and realistic for your Muslim book.</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 bg-white">
        <Container>
          <Row className="g-5">
            <Col lg={7} className="text-reading">
              <h3 className="classy-heading h2 mb-4">Who it’s for</h3>
              <p className="mb-5">Muslim authors and micro‑publishers with a finished (or nearly finished) book, ready to plan a launch that actually reaches readers.</p>

              <h3 className="classy-heading h2 mb-4">What we’ll cover</h3>
              <ul className="custom-list mb-5">
                <li><i className="bi bi-check-circle-fill list-icon"></i> <div>The full publisher campaign timeline: acquisitions, positioning, pre‑orders, proofs, launch, long‑tail.</div></li>
                <li><i className="bi bi-check-circle-fill list-icon"></i> <div>Core elements – audience research, metadata, cover briefs, early reviewer outreach, and school visits.</div></li>
                <li><i className="bi bi-check-circle-fill list-icon"></i> <div>How sales, marketing, publicity and rights teams work together on children’s titles.</div></li>
                <li><i className="bi bi-check-circle-fill list-icon"></i> <div>Muslim adaptations: masjid stalls instead of trade ads, Ramadan timing instead of Christmas, WhatsApp over press releases.</div></li>
              </ul>

              <h3 className="classy-heading h2 mb-4">You’ll leave with</h3>
              <ul className="custom-list mb-5">
                <li><i className="bi bi-star-fill list-icon"></i> <div>A fill‑in “Publisher Marketing Plan” template sized for solo creators.</div></li>
                <li><i className="bi bi-star-fill list-icon"></i> <div>Your own 12‑week launch roadmap with mainstream + halal actions side-by-side.</div></li>
                <li><i className="bi bi-star-fill list-icon"></i> <div>Priority list of 3–5 highest‑ROI steps for Muslim communities.</div></li>
              </ul>
              
              <hr className="my-5" />

              <h3 className="classy-heading h2 mb-4">About Your Instructor</h3>
              <div className="d-flex align-items-center mb-4">
                <img src="/images/sajeda/12.jpg" alt="Sajeda Faraz" className="rounded-circle me-4 shadow-sm" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                <div>
                  <h4 className="mb-1 classy-heading">Sajeda Faraz</h4>
                  <p className="text-muted mb-0">Creative Director & Mentor</p>
                </div>
              </div>
              <p>Led by Sajeda Faraz (that's me!), a creative director and mentor with over 15 years of experience in branding, design, and publishing, this live workshop offers more than theory.</p>
              <p>I’ve helped develop, position, and launch over 400+ children’s titles across indie and traditional publishing, and I know what makes a creator stand out in a crowded market. From writing bios that land school visits to crafting brands that attract publishers, I’ve done it all, and I’m here to walk you through it.</p>
              <p>This is an intimate, in-person experience designed to give you personalised feedback, direct access to expert insights, and the creative clarity you need to move forward with confidence.</p>
            </Col>

            <Col lg={5}>
              <Card className="sticky-card bg-light">
                <img src="/images/sajeda/11.jpg" alt="Workshop" className="img-fluid" style={{ borderBottom: '5px solid #1a365d' }} />
                <Card.Body className="p-4 p-md-5">
                  <h4 className="classy-heading mb-4">Workshop Details</h4>
                  <ul className="custom-list text-muted mb-4 fs-6">
                    <li><i className="bi bi-camera-video list-icon"></i> <div>4 x 60-minute live sessions (recorded for replay).</div></li>
                    <li><i className="bi bi-calendar-check list-icon"></i> <div>Weekly commitment (60 minutes every Thursday evening for 4 weeks).</div></li>
                    <li><i className="bi bi-chat-dots list-icon"></i> <div>Supportive Q&A + feedback on your work with ongoing support from Sajeda.</div></li>
                    <li><i className="bi bi-infinity list-icon"></i> <div>Lifetime access to all materials.</div></li>
                    <li><i className="bi bi-exclamation-triangle list-icon text-danger"></i> <div className="text-danger">I am unable to offer roll-overs of any missed sessions.</div></li>
                  </ul>
                  <div className="bg-white p-3 rounded-3 text-center mb-4 border">
                    <span className="text-muted d-block mb-1">Total Investment</span>
                    <span className="display-5 fw-bold" style={{ color: '#1a365d' }}>£189</span>
                  </div>
                  <a href={stripeLink} target="_blank" rel="noopener noreferrer" className="d-block">
                    <Button variant="primary" size="lg" className="w-100 rounded-pill fw-bold py-3 shadow-sm text-uppercase" style={{ letterSpacing: '1px' }}>Enrol Now via Stripe</Button>
                  </a>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Workshop2;